import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaperPlane: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPaperPlane"><Path d="M4.99839 11.25L2.29102 2.04492L21.908 11.9998L2.29102 21.9547L4.99829 12.75H10.0007V11.25H4.99839Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaperPlane;
